module.exports = __webpack_public_path__ + "static/kazim-yardimci-2-8d7002e65ac44e06788f75bf7fc98c0e.jpg";